// @flow

import React from 'react'
import styled from 'styled-components'
import type { ReactComponentStyled } from 'styled-components'
import type { Node } from 'react'
import useMentionsAndHashtags from '../useMentionsAndHashtags'
import Text from '../Sections/Text'

type CaptionProps = {
    caption?: string,
    children?: Node,
    isVerticalImage?: ?boolean,
    hashtags: string[]
}
const CaptionContainer: ReactComponentStyled<{}> = styled.div`
  padding: 8px 10% 8px 10%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 745px) {
    padding: 0px 16px;
  }
`
CaptionContainer.displayName = 'CaptionContainer'

function WebCaption ({ caption, children, isVerticalImage, hashtags }: CaptionProps) {
  const { parseMentionsAndHashtags } = useMentionsAndHashtags()

  let childrenBody = ''
  if (caption) {
    childrenBody = <Text size='P' fontColor='black' align='justify' text={parseMentionsAndHashtags(caption, hashtags)} />
  } else {
    childrenBody = children
  }
  return (
    <CaptionContainer>
      {childrenBody}
    </CaptionContainer>
  )
}

export default WebCaption
